import FoodOrdersListPanel from '../../components/food/FoodOrdersListPanel';
import PageShell from '../../components/layout/PageShell';
import PageHeader from '../../components/layout/PageHeader';

export default function FoodScheduledOrdersPage() {
  return (
    <PageShell>
      <PageHeader title="Scheduled Food Orders" subtitle="Upcoming orders scheduled for later delivery" />
      <FoodOrdersListPanel scope="scheduled" title="Scheduled Orders" />
    </PageShell>
  );
}
